import { ENUM_TYPE_DOWNLOAD } from 'constants/enum';
import { SET_OPEN_DOWNLOAD } from 'store/types/report';

const initialState = {
  openDownload: {
    isOpen: false,
    type: ENUM_TYPE_DOWNLOAD.CSV,
  },
};

const reportReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_OPEN_DOWNLOAD:
      return {
        ...state,
        openDownload: action?.payload,
      };
    default:
      return state;
  }
};

export default reportReducer;
